import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { APP_VERSION } from "@/version";

// Polls the deployed /version.json and prompts a refresh when a newer build is live.
export default function VersionChecker() {
  const notified = useRef(false);

  useEffect(() => {
    let stopped = false;

    const doRefresh = async () => {
      try {
        if ("serviceWorker" in navigator) {
          const regs = await navigator.serviceWorker.getRegistrations();
          await Promise.all(regs.map((r) => r.unregister()));
        }
        if (window.caches) {
          const keys = await caches.keys();
          await Promise.all(keys.map((k) => caches.delete(k)));
        }
      } catch (e) {
        /* best-effort cleanup */
      }
      window.location.reload();
    };

    const check = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return;
        const data = await res.json();
        if (!stopped && data.version && data.version !== APP_VERSION && !notified.current) {
          notified.current = true;
          toast("A new version is available", {
            id: "app-update",
            description: `Update to v${data.version} for the latest features and fixes.`,
            duration: Infinity,
            action: { label: "Refresh", onClick: doRefresh },
          });
        }
      } catch (e) {
        /* offline or transient — try again next tick */
      }
    };

    check();
    const iv = setInterval(check, 60000);
    const onFocus = () => check();
    window.addEventListener("focus", onFocus);
    return () => {
      stopped = true;
      clearInterval(iv);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  return null;
}
